import { render } from "./HeroIcon.vue?vue&type=template&id=2cab2cf1"
import script from "./HeroIcon.vue?vue&type=script&lang=js"
export * from "./HeroIcon.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__